var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "card card-default book-file" }, [
        _c(
          "div",
          { staticClass: "card-body", staticStyle: { height: "611.8px" } },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-4" }, [
                _c("p", [
                  _vm._v("단원\n            "),
                  _c(
                    "span",
                    { staticClass: "float-right" },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.uploadModalDepth1",
                              modifiers: { uploadModalDepth1: true }
                            }
                          ],
                          staticClass: "btn btn-xs mr-2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.popupShowDepth1 = true
                            }
                          }
                        },
                        [_vm._v("+ 단원등록")]
                      ),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isShowDepth1,
                              expression: "!isShowDepth1"
                            }
                          ],
                          staticClass: "btn btn-xs mr-2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.clickChangeData("depth1")
                              _vm.isShowDepth1 = true
                            }
                          }
                        },
                        [_vm._v("편집")]
                      ),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowDepth1,
                              expression: "isShowDepth1"
                            }
                          ],
                          staticClass: "btn btn-xs mr-2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.isShowDepth1 = false
                              _vm.resetOrderNum("depth1")
                              _vm.editContSeq = 0
                            }
                          }
                        },
                        [_vm._v("취소")]
                      ),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowDepth1,
                              expression: "isShowDepth1"
                            }
                          ],
                          staticClass: "btn btn-xs mr-2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.isShowDepth1 = false
                              _vm.saveChangeOrder("depth1")
                            }
                          }
                        },
                        [_vm._v("저장")]
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "table",
                  { staticClass: "table table-striped table-hover" },
                  [
                    _c(
                      "tbody",
                      { staticClass: "div_scroll" },
                      [
                        _c(
                          "tr",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.atrbInfo.depth1.length == 0,
                                expression: "atrbInfo.depth1.length==0"
                              }
                            ],
                            staticClass: "text-center"
                          },
                          [_c("td", [_vm._v("No matching records")])]
                        ),
                        _c(
                          "draggable",
                          {
                            attrs: {
                              options: {
                                group: "depth1",
                                disabled: !_vm.isShowDepth1
                              }
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeOrder(_vm.atrbInfo.depth1)
                              }
                            },
                            model: {
                              value: _vm.atrbInfo.depth1,
                              callback: function($$v) {
                                _vm.$set(_vm.atrbInfo, "depth1", $$v)
                              },
                              expression: "atrbInfo.depth1"
                            }
                          },
                          _vm._l(_vm.atrbInfo.depth1, function(item, index) {
                            return _c(
                              "tr",
                              {
                                key: item.contSeq + "1",
                                class:
                                  item.postTypeCd == "202004"
                                    ? ".item addBtn"
                                    : ".item"
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    class:
                                      item.postTypeCd == "202004"
                                        ? "table-info"
                                        : "",
                                    style: {
                                      backgroundColor:
                                        _vm.checkedDepth1[index] == true
                                          ? "#c1d5f8"
                                          : ""
                                    },
                                    attrs: { scope: "row" },
                                    on: {
                                      click: function($event) {
                                        _vm.atrbInfo.targetContSeqDepth2 = null
                                        _vm.getDepth3(item.contSeq)
                                        _vm.SelectChangeColor("depth1", index)
                                        _vm.isShowDepth2 = false
                                        _vm.isShowfiles = false
                                        _vm.selectUnitIndex[0] = index
                                        _vm.selectedContSeq = item.contSeq
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.editContSeq != item.contSeq,
                                            expression:
                                              "editContSeq!=item.contSeq "
                                          }
                                        ],
                                        staticStyle: {
                                          width: "calc(100% - 100px)"
                                        }
                                      },
                                      [
                                        _c("em", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                item.postTypeCd == "202005",
                                              expression:
                                                "item.postTypeCd == '202005'"
                                            }
                                          ],
                                          staticClass: "fa fa-caret-right"
                                        }),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.editContSeq !=
                                                  item.contSeq,
                                                expression:
                                                  "editContSeq!=item.contSeq"
                                              }
                                            ]
                                          },
                                          [_vm._v(_vm._s(item.title))]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              item.postTypeCd == "202004" &&
                                              _vm.editContSeq != item.contSeq,
                                            expression:
                                              "item.postTypeCd == '202004' && editContSeq !=item.contSeq"
                                          }
                                        ],
                                        staticClass: "btn btn-xs mr-2 additem",
                                        attrs: { variant: "outline-info" },
                                        on: {
                                          click: function($event) {
                                            _vm.addUnit(
                                              item,
                                              item.orderNum,
                                              "depth1"
                                            )
                                            _vm.popupShowDepthSmall = true
                                          }
                                        }
                                      },
                                      [_vm._v("+ 단계등록")]
                                    ),
                                    _vm.isShowDepth1
                                      ? _c("em", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.editContSeq != item.contSeq,
                                              expression:
                                                "editContSeq!=item.contSeq"
                                            }
                                          ],
                                          staticClass:
                                            "fa fa-edit fa-pull-right",
                                          on: {
                                            click: function($event) {
                                              return _vm.editAttr(item.contSeq)
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _c(
                                      "b-input-group",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.editContSeq == item.contSeq,
                                            expression:
                                              "editContSeq==item.contSeq"
                                          }
                                        ]
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: { type: "text" },
                                          model: {
                                            value: item.title,
                                            callback: function($$v) {
                                              _vm.$set(item, "title", $$v)
                                            },
                                            expression: "item.title"
                                          }
                                        }),
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                staticClass: "btn btn-xs mr-2",
                                                attrs: { variant: "warning" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteAttr(
                                                      _vm.contSeq,
                                                      item.contSeq,
                                                      item.orderNum,
                                                      _vm.atrbInfo,
                                                      "unit"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Delete")]
                                            ),
                                            _c(
                                              "b-btn",
                                              {
                                                staticClass: "btn btn-xs mr-2",
                                                attrs: { variant: "info" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.saveAttr(
                                                      item.title,
                                                      item.pcontSeq
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Save")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "col-md-4" }, [
                _c("p", [
                  _vm._v("차시\n            "),
                  _c("span", { staticClass: "float-right" }, [
                    _c(
                      "span",
                      { staticClass: "float-right" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-xs mr-2",
                            attrs: { variant: "outline-info" },
                            on: {
                              click: function($event) {
                                _vm.checkedDepth1Alert()
                                  ? (_vm.popupShowDepth2 = true)
                                  : (_vm.popupShowDepth2 = false)
                              }
                            }
                          },
                          [_vm._v("+ 차시등록")]
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isShowDepth2,
                                expression: "!isShowDepth2"
                              }
                            ],
                            staticClass: "btn btn-xs mr-2",
                            attrs: { variant: "outline-info" },
                            on: {
                              click: function($event) {
                                _vm.clickChangeData("depth2")
                                _vm.isShowDepth2 = true
                              }
                            }
                          },
                          [_vm._v("편집")]
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowDepth2,
                                expression: "isShowDepth2"
                              }
                            ],
                            staticClass: "btn btn-xs mr-2",
                            attrs: { variant: "outline-info" },
                            on: {
                              click: function($event) {
                                _vm.resetOrderNum("depth2")
                                _vm.isShowDepth2 = false
                                _vm.editContSeq = 0
                              }
                            }
                          },
                          [_vm._v("취소")]
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowDepth2,
                                expression: "isShowDepth2"
                              }
                            ],
                            staticClass: "btn btn-xs mr-2",
                            attrs: { variant: "outline-info" },
                            on: {
                              click: function($event) {
                                _vm.saveChangeOrder("depth2")
                                _vm.isShowDepth2 = false
                              }
                            }
                          },
                          [_vm._v("저장")]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _c(
                  "table",
                  { staticClass: "table table-striped table-hover" },
                  [
                    _c(
                      "tbody",
                      { staticClass: "div_scroll" },
                      [
                        _c(
                          "tr",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.atrbInfo.depth2.length == 0,
                                expression: "atrbInfo.depth2.length==0"
                              }
                            ],
                            staticClass: "text-center"
                          },
                          [_c("td", [_vm._v("No matching records")])]
                        ),
                        _c(
                          "draggable",
                          {
                            attrs: {
                              move: _vm.shouldDragToPosition,
                              options: {
                                group: "depth2",
                                disabled: !_vm.isShowDepth2
                              }
                            },
                            on: {
                              change: function($event) {
                                return _vm.changeOrder(
                                  _vm.atrbInfo.depth2,
                                  "depth2"
                                )
                              }
                            },
                            model: {
                              value: _vm.atrbInfo.depth2,
                              callback: function($$v) {
                                _vm.$set(_vm.atrbInfo, "depth2", $$v)
                              },
                              expression: "atrbInfo.depth2"
                            }
                          },
                          _vm._l(_vm.atrbInfo.depth2, function(item, index) {
                            return _c(
                              "tr",
                              {
                                key: item.orderNum + "2",
                                class:
                                  item.postTypeCd == "202006" ? "addBtn" : "",
                                attrs: {
                                  id:
                                    item.postTypeCd +
                                    "_" +
                                    item.contSeq +
                                    "_" +
                                    item.pcontSeq
                                }
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    class:
                                      item.postTypeCd == "202006"
                                        ? "table-primary"
                                        : "",
                                    style: {
                                      backgroundColor:
                                        _vm.checkedDepth2[index] == true
                                          ? "#c4c1f8"
                                          : ""
                                    },
                                    attrs: { scope: "row" },
                                    on: {
                                      click: function($event) {
                                        _vm.getAtrbFiles(item.contSeq)
                                        _vm.isShowfiles = false
                                        _vm.SelectChangeColor("depth2", index)
                                        _vm.selectUnitIndex[1] = index
                                        _vm.selectedContSeq = item.contSeq
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.editContSeq != item.contSeq,
                                            expression:
                                              "editContSeq!=item.contSeq "
                                          }
                                        ],
                                        staticStyle: {
                                          width: "calc(100% - 100px)"
                                        }
                                      },
                                      [
                                        _c("em", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                item.postTypeCd == "202007",
                                              expression:
                                                "item.postTypeCd == '202007'"
                                            }
                                          ],
                                          staticClass: "fa fa-caret-right"
                                        }),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.editContSeq !=
                                                  item.contSeq,
                                                expression:
                                                  "editContSeq!=item.contSeq "
                                              }
                                            ]
                                          },
                                          [_vm._v(_vm._s(item.title))]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              item.postTypeCd == "202006" &&
                                              _vm.editContSeq != item.contSeq,
                                            expression:
                                              "item.postTypeCd == '202006' && editContSeq !=item.contSeq"
                                          }
                                        ],
                                        staticClass: "btn btn-xs mr-2 additem",
                                        attrs: { variant: "outline-info" },
                                        on: {
                                          click: function($event) {
                                            _vm.addUnit(
                                              item,
                                              item.orderNum,
                                              "depth2"
                                            )
                                            _vm.popupShowDepthSmall = true
                                          }
                                        }
                                      },
                                      [_vm._v("+ 코너등록")]
                                    ),
                                    _vm.isShowDepth2 &&
                                    _vm.editContSeq != item.contSeq
                                      ? _c("em", {
                                          staticClass:
                                            "fa fa-edit fa-pull-right",
                                          on: {
                                            click: function($event) {
                                              return _vm.editAttr(item.contSeq)
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _c(
                                      "b-input-group",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.editContSeq == item.contSeq,
                                            expression:
                                              "editContSeq==item.contSeq"
                                          }
                                        ]
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: { type: "text" },
                                          model: {
                                            value: item.title,
                                            callback: function($$v) {
                                              _vm.$set(item, "title", $$v)
                                            },
                                            expression: "item.title"
                                          }
                                        }),
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                staticClass: "btn btn-xs mr-2",
                                                attrs: { variant: "warning" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteAttr(
                                                      _vm.contSeq,
                                                      item.contSeq,
                                                      item.orderNum,
                                                      _vm.atrbInfo,
                                                      "unit-seq"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Delete")]
                                            ),
                                            _c(
                                              "b-btn",
                                              {
                                                staticClass: "btn btn-xs mr-2",
                                                attrs: { variant: "info" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.saveAttr(
                                                      item.title,
                                                      item.pcontSeq
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Save")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "col-md-4" }, [
                _c("p", [
                  _vm._v("개체\n            "),
                  _c(
                    "span",
                    { staticClass: "float-right" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn btn-xs mr2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.checkedDepthFiles("3")
                                ? (_vm.popupShowDepth3 = true)
                                : (_vm.popupShowDepth3 = false)
                            }
                          }
                        },
                        [_vm._v("개체등록")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn btn-xs mr2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.checkedDepthFiles("4")
                                ? (_vm.popupShowDepth4 = true)
                                : (_vm.popupShowDepth4 = false)
                            }
                          }
                        },
                        [_vm._v("개체연결")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn btn-xs mr2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.checkedDepthFiles("6")
                                ? (_vm.popupShowDepth6 = true)
                                : (_vm.popupShowDepth6 = false)
                            }
                          }
                        },
                        [_vm._v("온라인콘텐츠연결")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn btn-xs mr2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.checkedDepthFiles("5")
                                ? (_vm.popupShowDepth5 = true)
                                : (_vm.popupShowDepth5 = false)
                            }
                          }
                        },
                        [_vm._v("용도변경")]
                      ),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isShowfiles,
                              expression: "!isShowfiles"
                            }
                          ],
                          staticClass: "btn btn-xs mr2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.clickChangeData("file")
                              _vm.isShowfiles = true
                            }
                          }
                        },
                        [_vm._v("편집")]
                      ),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowfiles,
                              expression: "isShowfiles"
                            }
                          ],
                          staticClass: "btn btn-xs mr2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.resetOrderNum("file")
                              _vm.isShowfiles = false
                              _vm.editContSeq = 0
                            }
                          }
                        },
                        [_vm._v("취소")]
                      ),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowfiles,
                              expression: "isShowfiles"
                            }
                          ],
                          staticClass: "btn btn-xs mr2",
                          attrs: { variant: "outline-info" },
                          on: {
                            click: function($event) {
                              _vm.saveChangeOrder("file")
                              _vm.isShowfiles = false
                            }
                          }
                        },
                        [_vm._v("저장")]
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "table",
                  { staticClass: "table table-striped table-hover" },
                  [
                    _c(
                      "tbody",
                      { staticClass: "div_scroll" },
                      [
                        _c(
                          "tr",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.atrbInfo.files.length == 0 ||
                                  _vm.atrbInfo.files.length == null,
                                expression:
                                  "atrbInfo.files.length == 0 || atrbInfo.files.length == null"
                              }
                            ],
                            staticClass: "text-center"
                          },
                          [_c("td", [_vm._v("No matching records")])]
                        ),
                        _c(
                          "draggable",
                          {
                            attrs: {
                              options: {
                                group: "files",
                                disabled: !_vm.isShowfiles
                              }
                            },
                            on: {
                              change: function($event) {
                                _vm.changeOrder(_vm.atrbInfo.files, "depth3")
                                _vm.checkColor(_vm.atrbInfo.files)
                              }
                            },
                            model: {
                              value: _vm.atrbInfo.files,
                              callback: function($$v) {
                                _vm.$set(_vm.atrbInfo, "files", $$v)
                              },
                              expression: "atrbInfo.files"
                            }
                          },
                          _vm._l(_vm.atrbInfo.files, function(item, index) {
                            return _c(
                              "tr",
                              { key: item.fileSeq + "3" },
                              [
                                _c("b-btn", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.editContSeq != item.fileSeq &&
                                        item.fileTypeCd != "211006"
                                          ? true
                                          : false,
                                      expression:
                                        "editContSeq!=item.fileSeq && item.fileTypeCd != '211006' ? true : false"
                                    }
                                  ],
                                  staticClass: "btn btn-xs mr-2 btn-down",
                                  on: {
                                    click: function($event) {
                                      _vm.popupShowFile = false
                                      _vm.downloadAs(
                                        item.fileDivCd,
                                        item.url,
                                        item.orgFileNm
                                      )
                                    }
                                  }
                                }),
                                _vm.isShowfiles
                                  ? _c("em", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.editContSeq != item.fileSeq,
                                          expression:
                                            "editContSeq!=item.fileSeq "
                                        }
                                      ],
                                      staticClass:
                                        "fa fa-edit fa-pull-right mr-2",
                                      staticStyle: { "margin-top": "1.25em" },
                                      on: {
                                        click: function($event) {
                                          return _vm.editAttr(item.fileSeq)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _c(
                                  "td",
                                  {
                                    staticClass: "file",
                                    attrs: { scope: "row" },
                                    on: {
                                      mousemove: function($event) {
                                        return _vm.findFile(item.fileSeq)
                                      },
                                      click: function($event) {
                                        return _vm.popupFile(
                                          _vm.atrbInfo.fileSeq,
                                          item.fileSeq,
                                          item.mappingSeq
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.editContSeq != item.fileSeq,
                                            expression:
                                              "editContSeq!=item.fileSeq"
                                          }
                                        ],
                                        attrs: { variant: "outline-info" }
                                      },
                                      [_vm._v(_vm._s(item.dispFileNm))]
                                    ),
                                    _c(
                                      "b-input-group",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.editContSeq == item.fileSeq,
                                            expression:
                                              "editContSeq==item.fileSeq"
                                          }
                                        ],
                                        on: {
                                          click: function($event) {
                                            _vm.atrbInfo.fileSeq = 0
                                          }
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: { type: "text" },
                                          model: {
                                            value: item.dispFileNm,
                                            callback: function($$v) {
                                              _vm.$set(item, "dispFileNm", $$v)
                                            },
                                            expression: "item.dispFileNm"
                                          }
                                        }),
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                staticClass: "btn btn-xs mr-2",
                                                attrs: { variant: "warning" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.popupShowFile = false
                                                    _vm.deleteAttr(
                                                      _vm.contSeq,
                                                      item.mappingSeq,
                                                      item.orderNum,
                                                      _vm.atrbInfo,
                                                      "file"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Delete")]
                                            ),
                                            _c(
                                              "b-btn",
                                              {
                                                staticClass: "btn btn-xs mr-2",
                                                attrs: { variant: "info" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.saveAttrFile(
                                                      item.dispFileNm,
                                                      item.pcontSeq,
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Save")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "file-kind-wrap" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.editContSeq !=
                                                  item.fileSeq,
                                                expression:
                                                  "editContSeq!=item.fileSeq"
                                              }
                                            ],
                                            staticClass: "file_kind"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      item.purpTypeCd != null
                                                        ? true
                                                        : false,
                                                    expression:
                                                      "item.purpTypeCd != null ? true : false "
                                                  }
                                                ],
                                                style: {
                                                  color:
                                                    _vm.atrbInfo.contColor[
                                                      index
                                                    ]
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.atrbInfo.contKind[index]
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      item.teacherUseYn == "Y"
                                                        ? true
                                                        : false,
                                                    expression:
                                                      "item.teacherUseYn == 'Y' ? true : false "
                                                  }
                                                ],
                                                style: {
                                                  color:
                                                    item.teacherUseYn == "Y"
                                                      ? "#FF0000"
                                                      : ""
                                                }
                                              },
                                              [_vm._v("교사")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      item.tutorUseYn == "Y"
                                                        ? true
                                                        : false,
                                                    expression:
                                                      "item.tutorUseYn == 'Y' ? true : false "
                                                  }
                                                ],
                                                style: {
                                                  color:
                                                    item.tutorUseYn == "Y"
                                                      ? "#708090"
                                                      : ""
                                                }
                                              },
                                              [_vm._v("강사")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      item.studentUseYn == "Y"
                                                        ? true
                                                        : false,
                                                    expression:
                                                      "item.studentUseYn == 'Y' ? true : false "
                                                  }
                                                ],
                                                style: {
                                                  color:
                                                    item.studentUseYn == "Y"
                                                      ? "#800000"
                                                      : ""
                                                }
                                              },
                                              [_vm._v("학생")]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.editContSeq !=
                                                  item.fileSeq,
                                                expression:
                                                  "editContSeq!=item.fileSeq"
                                              }
                                            ],
                                            staticClass: "file_kind"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      item.fileTypeCd ==
                                                      "211006"
                                                        ? true
                                                        : false,
                                                    expression:
                                                      "item.fileTypeCd == '211006' ? true : false"
                                                  }
                                                ]
                                              },
                                              [_vm._v("(온라인 콘텐츠)")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      item.fileTypeCd ==
                                                      "211005"
                                                        ? true
                                                        : false,
                                                    expression:
                                                      "item.fileTypeCd == '211005' ? true : false"
                                                  }
                                                ]
                                              },
                                              [_vm._v("(웹콘텐츠)")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      item.fileTypeCd ==
                                                      "211004"
                                                        ? true
                                                        : false,
                                                    expression:
                                                      "item.fileTypeCd == '211004' ? true : false"
                                                  }
                                                ]
                                              },
                                              [_vm._v("(웹콘텐츠링크)")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      item.ext != null
                                                        ? true
                                                        : false,
                                                    expression:
                                                      "item.ext != null  ? true : false"
                                                  }
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  "(" + _vm._s(item.ext) + ")"
                                                )
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      item.playEndTime != "0"
                                                        ? true
                                                        : false,
                                                    expression:
                                                      "item.playEndTime != '0' ? true : false "
                                                  }
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(item.playStartTime) +
                                                    " ~ " +
                                                    _vm._s(item.playEndTime) +
                                                    ")"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ]),
      _c(
        "b-modal",
        {
          attrs: { id: "fileModal", size: "xl", title: "개체정보" },
          model: {
            value: _vm.popupShowFile,
            callback: function($$v) {
              _vm.popupShowFile = $$v
            },
            expression: "popupShowFile"
          }
        },
        [
          _c("CsFilePageInfo", {
            key: "atrbInfo.fileSeq",
            attrs: {
              fileSeq: _vm.atrbInfo.fileSeq,
              mappingSeq: _vm.atrbInfo.mappingSeq,
              contSeq:
                _vm.atrbInfo.targetContSeqDepth2 == null
                  ? _vm.atrbInfo.targetContSeqDepth1
                  : _vm.atrbInfo.targetContSeqDepth2,
              orgContSeq: _vm.contSeq,
              isShow: _vm.isShow,
              atrbInfo: _vm.atrbInfo,
              saveType: "txt",
              parentType: "txt"
            },
            on: { "modal-state": _vm.popupClose, "get-data": _vm.GetDepthData }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "fileRegModal",
            size: "xl",
            title: "개체등록",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepth3,
            callback: function($$v) {
              _vm.popupShowDepth3 = $$v
            },
            expression: "popupShowDepth3"
          }
        },
        [
          _c("CsFileUploadPage", {
            key: "atrbInfo.contSeq",
            attrs: {
              contSeq:
                _vm.atrbInfo.targetContSeqDepth2 == null
                  ? _vm.atrbInfo.targetContSeqDepth1
                  : _vm.atrbInfo.targetContSeqDepth2,
              orgContSeq: _vm.contSeq,
              isShow: _vm.isShow,
              selectedContSeq: _vm.selectedContSeq,
              atrbInfo: _vm.atrbInfo,
              saveType: "txt"
            },
            on: { "get-data": _vm.refreshFiles, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "usingModalFiles",
            size: "xl",
            title: "개체용도변경",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepth5,
            callback: function($$v) {
              _vm.popupShowDepth5 = $$v
            },
            expression: "popupShowDepth5"
          }
        },
        [
          _c("CsFileUsingPage", {
            key: "atrbInfo.contSeq",
            attrs: {
              filedata: _vm.atrbInfo.files,
              postTypeCd: _vm.atrbInfo.targetPostTypeCd,
              atrbInfo: _vm.atrbInfo,
              index: _vm.selectUnitIndex,
              title: _vm.data.row.textbookNm,
              pContSeq1: _vm.atrbInfo.targetContSeqDepth1,
              pContSeq2: _vm.atrbInfo.targetContSeqDepth2,
              orgContSeq: _vm.contSeq,
              isShow: _vm.isShow
            },
            on: {
              "refresh-files": _vm.GetDepthData,
              "modal-state": _vm.popupClose
            }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "unitModalDepth",
            size: "ll",
            title: "하위등록",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepthSmall,
            callback: function($$v) {
              _vm.popupShowDepthSmall = $$v
            },
            expression: "popupShowDepthSmall"
          }
        },
        [
          _c("CsUnitPage", {
            key: "atrbInfo.uploadSeq",
            attrs: {
              fileSeq: _vm.atrbInfo.fileSeq,
              param: _vm.saveUnitInfo,
              atrbInfo: _vm.atrbInfo
            },
            on: { "modal-state": _vm.popupClose, "title-push": _vm.PushItem }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "uploadModalDepth1",
            size: "ll",
            title: "단원등록",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepth1,
            callback: function($$v) {
              _vm.popupShowDepth1 = $$v
            },
            expression: "popupShowDepth1"
          }
        },
        [
          _c("CsUploadpage", {
            key: "atrbInfo.uploadSeq",
            attrs: {
              fileSeq: _vm.atrbInfo.fileSeq,
              orderNum: _vm.atrbInfo.depth1.length,
              version: _vm.unit,
              atrbInfo: _vm.atrbInfo,
              pContSeq: _vm.contSeq,
              orgContSeq: _vm.contSeq
            },
            on: { "title-push": _vm.PushItem, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "uploadModalDepth2",
            size: "ll",
            title: "차시단계등록",
            "hide-footer": ""
          },
          model: {
            value: _vm.popupShowDepth2,
            callback: function($$v) {
              _vm.popupShowDepth2 = $$v
            },
            expression: "popupShowDepth2"
          }
        },
        [
          _c("CsUploadpage", {
            key: "atrbInfo.uploadSeq",
            attrs: {
              fileSeq: _vm.atrbInfo.fileSeq,
              orderNum: _vm.atrbInfo.depth2.length,
              version: _vm.unit_seq,
              atrbInfo: _vm.atrbInfo,
              pContSeq: _vm.atrbInfo.targetContSeqDepth1,
              orgContSeq: _vm.contSeq
            },
            on: { "title-push": _vm.PushItem, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "uploadModalFiles", size: "xl", title: "개체연결" },
          model: {
            value: _vm.popupShowDepth4,
            callback: function($$v) {
              _vm.popupShowDepth4 = $$v
            },
            expression: "popupShowDepth4"
          }
        },
        [
          _c("CsTextBookFiles", {
            attrs: {
              extFileId: _vm.data.row.extFileId,
              atrbInfo: _vm.atrbInfo,
              pContSeq1: _vm.atrbInfo.targetContSeqDepth1,
              pContSeq2: _vm.atrbInfo.targetContSeqDepth2,
              orgContSeq: _vm.contSeq
            },
            on: { "get-data": _vm.getDepthData, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "uploadModalFiles",
            size: "xl",
            title: "온라인콘텐츠연결"
          },
          model: {
            value: _vm.popupShowDepth6,
            callback: function($$v) {
              _vm.popupShowDepth6 = $$v
            },
            expression: "popupShowDepth6"
          }
        },
        [
          _c("CsTextBookFilesOnline", {
            attrs: {
              extFileId: _vm.data.row.extFileId,
              atrbInfo: _vm.atrbInfo,
              pContSeq1: _vm.atrbInfo.targetContSeqDepth1,
              pContSeq2: _vm.atrbInfo.targetContSeqDepth2,
              orgContSeq: _vm.contSeq
            },
            on: { "get-data": _vm.getDepthData, "modal-state": _vm.popupClose }
          }),
          _c("loading", {
            attrs: { active: _vm.modalLoading, "is-full-page": true }
          })
        ],
        1
      ),
      _c("loading", {
        attrs: { active: _vm.modalLoading, "is-full-page": true }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }